import { render } from "./date.vue?vue&type=template&id=23a42887"
import script from "./date.vue?vue&type=script&lang=js"
export * from "./date.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23a42887"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23a42887', __exports__)) {
    console.log('reload')
    api.reload('23a42887', __exports__)
  }
  
  module.hot.accept("./date.vue?vue&type=template&id=23a42887", () => {
    console.log('re-render')
    api.rerender('23a42887', render)
  })

}


export default __exports__